export enum Routes {
  FleetDamageRouter = "*",
  DamageSearchPageRouter = "/fleet/damage/search",
}
